import { Avatar, Tooltip } from '@mantine/core';
import { IconLink, IconWorld } from '@tabler/icons-react';

import type { ResourceAvatarViewProps } from './ResourceAvatar.types';

const isFallbackUrl = (url: string) => url.includes('fallback');

export function ResourceAvatarView({
  variant,
  name,
  photoUrl,
  size = 22,
  isConnected = false,
  connectedLabel,
}: ResourceAvatarViewProps) {
  if (variant === 'employee') {
    const src = photoUrl && !isFallbackUrl(photoUrl) ? photoUrl : null;
    return <Avatar src={src} name={name} color="initials" size={size} radius="xl" />;
  }

  const badgeSize = Math.max(12, Math.round(size * 0.47));
  const iconSize = Math.max(6, Math.round(size * 0.27));

  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <Avatar color="orange" alt={name} radius="xl" size={size}>
        <IconWorld size={Math.round(size * 0.65)} />
      </Avatar>
      {isConnected && (
        <Tooltip label={connectedLabel} withArrow disabled={!connectedLabel}>
          <div
            data-testid="partner-connected-indicator"
            style={{
              position: 'absolute',
              bottom: -2,
              right: -2,
              width: badgeSize,
              height: badgeSize,
              borderRadius: '50%',
              background: 'var(--mantine-color-green-6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid var(--mantine-color-body)',
            }}
          >
            <IconLink size={iconSize} color="white" />
          </div>
        </Tooltip>
      )}
    </div>
  );
}
